<template>
	<editor v-bind="$props" @blur="onBlur" @input="onInput" @keyup="onKeyup" @focus="onFocus" @upload="onUpload"></editor>
</template>

<script>
import CKEditor from '@/lib/components/Shared/editor/ckeditor/CKEditor';
import { defineComponent } from 'vue';
import { textEditorController } from '@/lib/components/Shared/editor/TextEditor.controller';
import { useEditorProps } from '@/lib/components/Shared/editor/editorProps';
import { useUploadProps } from '@/lib/components/Shared/editor/uploads/uploadsProps';

export default defineComponent({
	name: 'TextEditor',
	components: {
		editor: CKEditor,
	},

	props: {
		...useUploadProps,
		...useEditorProps,
	},

	setup(props, { emit }) {
		return textEditorController(props, emit);
	},
});
</script>
